<template>
  <div class="hy-index">
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title active" style="margin-bottom:10px;">
          发票详情
        </h5>
        <van-list>
          <van-cell>
            <div class="textbox">
              <div class="order_nobox">
                <div class="order_statusbox border">
                  <span class="o_time">发票状态：</span>
                  <span class="o_status">
                    <template v-if="piaobox.status == 1">
                      待审核
                    </template>
                    <template v-if="piaobox.status == 2">
                      审核未通过
                    </template>
                    <template v-if="piaobox.status == 3">
                      审核通过
                    </template>
                    <template v-if="piaobox.status == 4">
                      已取消
                    </template>
                  </span>
                </div>
                <div class="order_statusbox border" v-if="piaobox.status == 2">
                  <span class="o_time">未通过原因：</span>
                  <span class="o_status">{{piaobox.desc}}</span>
                </div>
                <div class="order_statusbox border">
                  <span class="o_time">申请时间：</span>
                  <span class="o_status">{{piaobox.create_time}}</span>
                </div>
                <div class="order_statusbox border">
                  <span class="o_time">申请号：</span>
                  <span class="o_status">{{piaobox.invoice_no}}</span>
                </div>
                <div class="order_statusbox border">
                  <span class="o_time">订单编号：</span>
                  <span class="o_status">
                    <template v-for="item in piaobox.order">
                      {{item}}
                    </template>
                  </span>
                </div>
                  <div class="order_statusbox border">
                    <span class="o_time">发票类型：</span>
                    <span class="o_status">{{piaobox.invoice_type}}</span>
                  </div>
                <div class="order_statusbox border">
                  <span class="o_time">发票抬头：</span>
                  <span class="o_status">{{piaobox.title}}</span>
                </div>
               <div class="order_statusbox border" v-if="piaobox.tax_no">
                  <span class="o_time">税号：</span>
                  <span class="o_status">{{piaobox.tax_no}}</span>
                </div>
                <div class="order_statusbox border" v-if="piaobox.bank_name">
                  <span class="o_time">开户行：</span>
                  <span class="o_status">{{piaobox.bank_name}}</span>
                </div>
                <div class="order_statusbox border" v-if="piaobox.bank_name">
                  <span class="o_time">地址：</span>
                  <span class="o_status">{{piaobox.bank_name}}</span>
                </div>
                <div class="order_statusbox border" v-if="piaobox.tel">
                  <span class="o_time">电话：</span>
                  <span class="o_status">{{piaobox.tel}}</span>
                </div>
                <div class="btnBox" v-if="piaobox.status == 1">
                  <a class="nav-link blue" @click="quxiao" ><span class="text">取消申请</span></a>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <router-link class="iconfont fixed-link" to="/invoiceList">&#xe66a;</router-link>
    </div>
  </div>
</template>
<script>
  import {
    formatDates
  } from "../../assets/js/date"
  export default {
    data() {
      return {
         piaobox:{}
      };
    },
    created() {
      var _this = this;
      _this.id = _this.$route.params.id;
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });
      _this.onLoad();
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      /* 初始化数据列表 */
      onLoad(page, pagesize) {
        var _this = this;
        let url = "/invoice/getInvoiceDet";
        let params = {
          id:_this.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.piaobox = res.posts.data;
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
      quxiao(){
        var _this = this;

        _this.$dialog.confirm({
          message: '是否确定取消发票申请？',
        })
          .then(() => {
          // on confirm
          let url = "/invoice/cancel";
          let params = {
            id:_this.id
          };
          _this.$post(url, params).then(res => {
            if (res.code == "1") {
              _this.$toast(res.msg);
              setTimeout(function(){
                _this.$router.go(-1);
              },1000)
            } else {
              _this.$toast(res.msg);
            }
          }, function(res) {
            console.log(res.msg);
          });
        })
          .catch(() => {
          // on cancel
        });

      }
    }
  };
</script>
<style lang="less">
  .order_nobox {
    width: 100%;
    padding: 10px 0px;

    .order_statusbox {
      width: 100%;
      overflow: hidden;
      padding: 0 15px;

      .van-checkbox {
        float: left;
        max-width: 20%;
      }

      span {
        color: #999;
        font-size: 28px;

        &.o_time {
          float: left;
        }

        &.o_status {
          float: right;
          color: #fe6333;
        }
      }

      &.border {
        border-top: none;
        border-bottom: 2px solid #ebebeb;
        padding: 15px;
      }
    }
  }
</style>
